"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIn = void 0;
function updateIn(...args) {
    if (args.length === 2) {
        return function curriedUpdateIn(obj) {
            return updateIn(obj, ...args);
        };
    }
    else {
        const [o, path, updater] = args;
        function updateDeep(o, [p, ...rest]) {
            if (p === fin) {
                const nextVal = updater(o);
                if (nextVal === o)
                    throw new UnchangedError;
                return nextVal;
            }
            return Object.assign(Object.assign({}, o), { [p]: updateDeep(o[p], rest) });
        }
        try {
            return updateDeep(o, path.concat([fin]));
        }
        catch (e) {
            if (e instanceof UnchangedError)
                return o;
            throw e;
        }
    }
}
exports.updateIn = updateIn;
class UnchangedError extends Error {
}
;
const fin = '5e6fc9d6-1595-40c8-884d-6fd0cff01f7a';
// updateIn({a: { 
//     c: { d: 1},
//     b: { c: { d: 'redfd' }}}}, ['a', 'b', ''], (x => ));
// type t = keyof string;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBkYXRlSW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXBkYXRlSW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBK0JBLFNBQWdCLFFBQVEsQ0FBQyxHQUFHLElBQVc7SUFDbkMsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUNuQixPQUFPLFNBQVMsZUFBZSxDQUFDLEdBQVE7WUFDcEMsT0FBUSxRQUFnQixDQUFDLEdBQUcsRUFBRSxHQUFHLElBQUksQ0FBQyxDQUFDO1FBQzNDLENBQUMsQ0FBQTtLQUNKO1NBQU07UUFDSCxNQUFNLENBQUMsQ0FBQyxFQUFFLElBQUksRUFBRSxPQUFPLENBQUMsR0FBRyxJQUEyQyxDQUFDO1FBRXZFLFNBQVMsVUFBVSxDQUFDLENBQWdCLEVBQUUsQ0FBQyxDQUFDLEVBQUUsR0FBRyxJQUFJLENBQVE7WUFDckQsSUFBSSxDQUFDLEtBQUssR0FBRyxFQUFFO2dCQUNYLE1BQU0sT0FBTyxHQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDM0IsSUFBSSxPQUFPLEtBQUssQ0FBQztvQkFBRSxNQUFNLElBQUksY0FBYyxDQUFDO2dCQUM1QyxPQUFPLE9BQU8sQ0FBQzthQUNsQjtZQUVELHVDQUNRLENBQVMsS0FDYixDQUFDLENBQUMsQ0FBQyxFQUFFLFVBQVUsQ0FBRSxDQUFTLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLElBQ3ZDO1FBQ0wsQ0FBQztRQUNELElBQUk7WUFDQSxPQUFPLFVBQVUsQ0FBQyxDQUFDLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUM1QztRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1IsSUFBSSxDQUFDLFlBQVksY0FBYztnQkFBRSxPQUFPLENBQUMsQ0FBQztZQUMxQyxNQUFNLENBQUMsQ0FBQztTQUNYO0tBQ0o7QUFDTCxDQUFDO0FBM0JELDRCQTJCQztBQUNELE1BQU0sY0FBZSxTQUFRLEtBQUs7Q0FBRztBQUFBLENBQUM7QUFDdEMsTUFBTSxHQUFHLEdBQUcsc0NBQXNDLENBQUM7QUFFbkQsa0JBQWtCO0FBQ2xCLGtCQUFrQjtBQUNsQiwyREFBMkQ7QUFFM0QseUJBQXlCIn0=